import React, { useEffect, useState } from "react";
import {
  CameraMini,
  CrossFillMini,
  infoOutlineMini,
} from "../../assets/SvgIcons";
import toast from "react-hot-toast";
import axiosInstance from "../../redux/helpers/axios";
import axios from "axios";

const imagesArray = [
  {
    url: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/1.png",
    label: "Front",
  },
  {
    url: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/2.png",
    label: "Left",
  },
  {
    url: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/3.png",
    label: "Right",
  },
  {
    url: "https://aleeha-test.s3.ap-southeast-1.amazonaws.com/4.png",
    label: "Back",
  },
  // {
  //   url: "https://static.chrono24.com/images/default/private-seller/offer-perspectives/brace-quad.jpg",
  //   label: "Strap/bracelet",
  // },
  // {
  //   url: "https://static.chrono24.com/images/default/private-seller/offer-perspectives/papers-quad.jpg",
  //   label: "Scope of delivery",
  // },
];

const Step4 = ({ images, setImages }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    const url = await handleImgUpload(file);

    setImages([...images, url]);
  };

  const generateLinkFromString = (str) => {
    return str?.split("")?.length > 0
      ? `${Math.floor(1000000000 + Math.random() * 9000000000)}-${str
          ?.toLowerCase()
          ?.replace(/\s+/g, "-")}`
      : ""; // Replace spaces (or multiple spaces) with hyphens
  };

  const handleImgUpload = async (file) => {
    const id = toast.loading("Loading...");
    try {
      const response = await axiosInstance.get(`/utils/aws/get-presigned-url`, {
        params: {
          filename: generateLinkFromString(file.name),
          fileType: file.type,
        },
      });

      const { url, objectUrl } = response.data;
      await axios.put(url, file, {
        headers: {
          "Content-Type": file.type,
        },
      });
      toast.dismiss(id);
      return objectUrl;
    } catch (error) {
      console.log(error);

      toast.error("Image upload failed!", { id: id });
    }
  };

  return (
    <section className="">
      <h1 className="lg:text-4xl md:text-3xl sm:text-xl">
        Upload photos of your watch
      </h1>
      <p className="text-[14px] mt-4 mb-8">
        Photos act as a quality seal for your listing. Upload at least 5 photos
        to present your watch in the best possible way.
      </p>

      <div className="grid grid-cols-2 gap-4 mt-8">
        <div className="w-full">
          <input
            onChange={handleImageChange}
            type="file"
            id="LogoUpload"
            className="hidden"
            multiple
          />

          <label
            htmlFor="LogoUpload"
            className=" border border-secondary text-secondary border-dashed py-3.5 rounded-lg   flex  justify-center items-center gap-6 cursor-pointer"
          >
            {images.length <= 0 ? (
              <div className="w-full px-16 py-12 text-gray-500 flex flex-col justify-center items-center">
                {CameraMini}
                <p className="text-[14px] font-medium  mt-2 ">Upload photos</p>
              </div>
            ) : (
              <div className="mx-2 gap-4  grid grid-cols-2 flex">
                {images.map((src, index) => (
                  <div key={index} className="">
                    <img
                      src={src}
                      alt={`Preview ${index + 1}`}
                      className="w-[200px] h-[150px] object-cover rounded-lg shadow-md"
                    />
                  </div>
                ))}
              </div>
            )}
          </label>
        </div>

        <div className="w-full h-full text-[14px] bg-primarylight p-4 rounded-lg">
          <p className="font-medium mb-3">Instructions</p>
          <p className="">
            Use gentle, even lighting to reduce shadows and enhance the
            product's features. Maintain a clean, neutral background to ensure
            the product remains the focal point.
          </p>
        </div>
      </div>

      {/* Info Box */}
      <div className="text-[14px] bg-primarylight p-6 rounded-lg flex items-center gap-2 mt-6">
        {infoOutlineMini}{" "}
        <p className="underline cursor-pointer" onClick={openModal}>
          Creating Great Photos
        </p>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-2xl w-full max-w-[720px]">
            <div className="flex justify-between items-start">
              <h1 className="lg:text-3xl md:text-2xl sm:text-xl">
                Creating Great Photos
              </h1>
              <button className="" onClick={closeModal}>
                {CrossFillMini}
              </button>
            </div>
            <ul className="text-[14px] list-disc ml-4 mt-4 mb-8">
              <li>
                Photograph your watch under natural light or in a bright
                environment.
              </li>
              <li>Photograph your watch from all angles.</li>
              <li>
                Make sure that any defects, such as scratches or dents, are
                clearly visible.
              </li>
            </ul>

            <div className="flex gap-3 items-start mt-6">
              {imagesArray?.map((img, index) => {
                return (
                  <div className="flex flex-col justify-center items-center p-2">
                    <img src={img?.url} alt="" height={150} width={150} />
                    <p className="text-[14px] mt-2 text-center">{img?.label}</p>
                  </div>
                );
              })}
            </div>

            <div className="w-full flex justify-end mt-10">
              <button
                className="mt-4 px-12 py-2.5 bg-secondary text-white rounded-lg"
                onClick={closeModal}
              >
                Got it!
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Step4;
